import React from "react";

import { TablePagination } from "@mui/material";

type AppTablePagenationProps = {
  fontSize?: string;
  fontColor?: string;
  arrowButtonColor?: string;
  showRowsPerPageOptions?: boolean;
  showLabelRowsPerPage?: boolean;
  totalCount: number;
  limit: number;
  pageNo: number;
  onPageChange: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number,
  ) => void;
  handleRowsChange: (value: number) => void;
};

const AppTablePagenation = (props: AppTablePagenationProps) => {
  return (
    <TablePagination
      labelRowsPerPage={
        props.showLabelRowsPerPage !== false ? (
          <span
            style={{
              fontSize: props.fontSize,
              fontWeight: 500,
              color: props.fontColor,
            }}
          >
            Rows per page
          </span>
        ) : undefined
      }
      labelDisplayedRows={(details) => (
        <span
          style={{
            fontSize: props.fontSize,
            fontWeight: 500,
            color: props.fontColor,
          }}
        >
          {details.from} - {details.to} of {details.count}
        </span>
      )}
      rowsPerPageOptions={
        props.showRowsPerPageOptions !== false
          ? [10, 30, 50, 100, 150, 200]
          : []
      }
      component="div"
      count={props.totalCount}
      rowsPerPage={props.limit}
      page={props.totalCount === 0 ? 0 : props.pageNo - 1}
      onPageChange={(event, page_no) => {
        props.onPageChange(event, page_no + 1);
      }}
      onRowsPerPageChange={(event) =>
        props.handleRowsChange(parseInt(event.target.value, 10))
      }
      sx={{
        "& .MuiTablePagination-actions": {
          "& .MuiIconButton-root": {
            color: props.arrowButtonColor,
          },
        },
      }}
    />
  );
};

export default React.memo(AppTablePagenation);
